import React from 'react'

interface ICardProps {
  active?: boolean
  children: React.ReactNode
  className?: string
  error?: boolean
}

const Card = ({ active = false, children, className = '', error = false }: ICardProps) => {
  return (
    <div
      className={`b-rad-8 p2 rp-card-container ${active ? 'card-active' : ''} ${
        error ? 'card-error' : ''
      } ${className}`}
    >
      {children}
    </div>
  )
}

export default Card



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/Card.tsx